import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import BaseInputComponent from '@/slango-multiverse/components/inputs/BaseInputComponent';
import { certificates, machines } from '@/helpers/APIconnection';
import { desktopAppComunication } from '@/helpers/desktop-controller';
import { globalProperties } from '@/main.js';
import store from '@/store';
export const UtilitiesController = {
  NormalizedInput: function (items, normalize = {}) {
    return items.map(item => {
      return {
        label: normalize.label ? globalProperties.$getNestedProperty(item, normalize.label) : item,
        value: normalize.value ? globalProperties.$getNestedProperty(item, normalize.value) : item
      };
    });
  },
  GetLocalMachine: async function () {
    const hashCode = await desktopAppComunication("GetMachineHashCode");
    if (!hashCode) return;
    const response = await machines.get('?machineHashCode=' + hashCode);
    if (response?.status === 200) return response.data.items?.[0];
  },
  GetMachines: async function ({
    shared,
    includeLocalMachine
  }) {
    this.loading = true;
    let matchedLocalMachine;
    let items = [];
    if (shared) {
      const response = await machines.get();
      if (response?.status === 200) {
        items = response.data?.items ?? [];
      }
    }
    if (this.$embedded && includeLocalMachine) {
      const hashcode = await desktopAppComunication("GetMachineHashCode");
      const local = {
        name: 'Este dispositivo',
        local: true,
        certificates: await desktopAppComunication("GetCertificatesList")
      };
      matchedLocalMachine = items.find(i => i.machineHashCode === hashcode);
      if (matchedLocalMachine) {
        matchedLocalMachine.sync = true;
        matchedLocalMachine.savedAs = matchedLocalMachine.name;
        this.currentLocalMachine = matchedLocalMachine;
        Object.assign(matchedLocalMachine, local);
      } else items.unshift(local);
    }
    items.forEach(machine => {
      machine.shared = !machine.local;
      machine.accessData = this.ManangeLastAcess(machine.lastAccess);
      machine.certificates = machine.certificates?.map(cert => {
        if (cert.data) cert = cert.data;
        cert.machine = {
          ...machine,
          certificates: undefined
        };
        cert.normalizedName = cert.subject?.CN;
        cert.machineName = machine?.name;
        cert.machineAndNameSearch = `${cert.machineName}${cert.normalizedName}`.toLowerCase();
        cert.selected = false;
        return cert;
      });
    });
    if (this.computedType.machines && this.selectable) items = JSON.parse(this.$safeStringify(items));
    if (this.computedType.machines && !this.value?.length) this.value = matchedLocalMachine || items[0];

    // if ( normalizedItems ) { return UtilitiesController.NormalizedInput(items, { label: 'name' }) }

    this.loading = true;
    return items;
  }
};
export default {
  extends: BaseInputComponent,
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    required: {
      default: true
    },
    externalSearchKeyword: String,
    // Search keywords bridge for outer search input
    searchInputField: {
      type: Boolean,
      default: true
    },
    // Enable certificates serach input
    persistentSelection: {
      type: Boolean,
      default: true
    },
    // Save selected certificates across component updates

    readonly: Boolean,
    type: {
      type: String,
      default: 'certificates'
    },
    shared: {
      type: Boolean,
      default: !store.state.embedded
    },
    // Show other machine certificates
    selectable: {
      type: Boolean,
      default: false
    },
    includeLocalMachine: {
      type: Boolean,
      default: true
    }
  },
  emit: ['on-preset-certificate', 'on-selected-shared', 'on-selected-machine'],
  data: function () {
    return {
      loading: false,
      internalSearchKeyword: undefined,
      currentLocalMachine: undefined,
      selectedMachine: undefined,
      loadedData: undefined,
      texts: {
        machineLabel: machine => {
          if (this.computedType.certificates) return machine.local ? `Certificados locales (${machine.savedAs ?? "No sicronizado"})` : machine.name;else machine.name;
        },
        machineCertificatesSubtitle: machine => machine.certificates?.length ? `${machine.certificates.length} ${machine.certificates.length === 1 ? 'certificado' : 'certificados'}` : 'Sin certificados'
      }
    };
  },
  computed: {
    CertificatesList() {
      return this.loadedData.flatMap(machine => machine.certificates ?? []);
    },
    SelectedCertificates() {
      return this.CertificatesList.filter(c => c.selected);
    },
    ThereAreShared() {
      return this.loadedData?.some(m => !m.local);
    },
    keyword() {
      return (this.internalSearchKeyword || '') + (this.externalSearchKeyword || '');
    },
    NoCertsText() {
      if (this.loadedData?.length) return `No se han encontrado resultados para la búsqueda <b>${this.$noXSS(this.keyword)}</b>`;else if (this.$embedded) return 'No tienes certificados';else {
        this.$nextTick(() => {
          const element = document.querySelector('#open-desktop-app-link');
          if (element) element.onclick = this.$openTaskRecorder;
        });
        return 'No podemos ver tus certificados desde la web, puedes usar la <span id="open-desktop-app-link" class="hover:underline cursor-pointer">aplicación de escritorio</span> para habilitar esta opción.';
      }
    },
    SelectorConfig() {
      if (this.computedType.certificates) return {
        label: 'Selección de certificados',
        noItems: 'No hay certificados disponibles'
      };else if (this.computedType.machines) return {
        label: 'Selección de dispositivos',
        noItems: 'No hay dispositivos compartidos disponibles'
      };
      return {};
    },
    computedType() {
      return {
        [this.type]: true
      };
    },
    CurrentConfigs() {
      const groups = {
        emails: [],
        cccs: []
      };
      this.selectedMachine?.configs?.forEach(c => {
        if (c.emailSettings) groups.emails.push(c);
        if (c.cccList?.length) groups.cccs.push(c);
      });
      return groups;
    }
  },
  watch: {
    value() {
      let selectedMachine;
      if (this.computedType.certificates && Array.isArray(this.modelValue)) {
        selectedMachine = this.loadedData?.find(m => this.modelValue[0]?.machine._id === m._id);
      } else if (this.computedType.machines) {
        selectedMachine = Array.isArray(this.modelValue) ? this.modelValue[0] : this.modelValue;
      }
      this.$emit('on-selected-machine', selectedMachine);
      this.$emit('on-selected-shared', !!selectedMachine?.shared);
    }
  },
  created() {
    this.GetData();
    if (!this.persistentSelection) {
      delete this.$state.certificates;
    }
  },
  methods: {
    GetData: async function () {
      if (this.loading) return;
      this.loading = true;
      this.loadedData = await UtilitiesController.GetMachines.bind(this)({
        shared: this.shared,
        includeLocalMachine: this.includeLocalMachine
      });
      if (!this.readonly && this.loadedData?.length === 1) {
        this.selectedMachine = this.loadedData[0];
      }
      if (this.persistentSelection) {
        this.CertificatesList?.forEach(cert => {
          if (this.$state.certificates?.findIndex(c => c._id ? c._id === cert._id : c.serialNumber === cert.serialNumber && c.machine?._id === cert.machine?._id) > -1) this.ToggleCertificateSelection(cert);
        });
      }
      this.loading = false;
    },
    CustomCertificateSearchFilter: function (itemTitle, queryText, item) {
      // eslint-disable-line

      return (item.raw.machineAndNameSearch ?? '').includes(queryText?.replaceAll(' ', '').toLowerCase() ?? '');
    },
    UpdateSelectedCertificate: function () {
      if (!this.CertificatesList?.length) return;
      this.value = this.SelectedCertificates;
      if (this.persistentSelection) {
        this.$state.certificates = this.value;
      }
    },
    ToggleMachineCertificates: function (machine) {
      if (!this.multiple || !machine.certificates?.length) return;
      const allSelected = machine.certificates.every(c => c.selected);
      machine.certificates.forEach(c => c.selected = !allSelected);
      this.UpdateSelectedCertificate();
    },
    ToggleCertificateSelection: function (certificate) {
      if (!certificate) return;
      this.selectedMachine = this.loadedData.find(m => m._id === certificate.machine._id || m.machineHashCode === certificate.machine.machineHashCode);
      if (this.readonly) return;
      if (this.multiple) {
        certificate.selected = !certificate.selected;
      } else {
        const toggleTo = !certificate.selected;
        this.CertificatesList.forEach(c => c.selected = false);
        certificate.selected = toggleTo;
      }
      this.UpdateSelectedCertificate();
    },
    // ==========| Local machine |==========

    SyncDigitalCertificates: async function () {
      if (!this.$embedded) return;
      const certs = await desktopAppComunication("GetCertificatesList");
      this.$state.ui.promptModal = {
        input: {},
        title: 'Introduce un nombre para identificar tu dispositivo',
        text: `Vas a sincronizar ${certs?.length} certificados`,
        footer: [{
          variant: 'outlined',
          text: 'Cancelar',
          click: () => delete this.$state.ui.promptModal
        }, {
          variant: 'primary',
          text: 'Guardar',
          click: async () => {
            if (!this.$state.ui.promptModal.input.value?.trim()) return;
            await certificates.post(`?machineName=${this.$state.ui.promptModal.input.value.trim()}`, {
              machineHashCode: await desktopAppComunication("GetMachineHashCode"),
              digitalCertificates: certs
            });
            await this.GetData();
            delete this.$state.ui.promptModal;
          }
        }]
      };
    },
    RemoveMachine: function (machine) {
      this.$state.ui.promptModal = {
        title: `Eliminar ${machine.name}`,
        text: `¿Seguro/a que quieres eliminar <b>${machine.name}</b> y sus certificados?`,
        footer: [{
          variant: 'outlined',
          text: 'Cancelar',
          click: () => delete this.$state.ui.promptModal
        }, {
          variant: 'primary',
          text: 'Eliminar',
          click: async () => {
            const res = await machines.delete(machine._id);
            if (res?.status === 200) {
              this.selectedMachine = undefined;
              delete this.$state.ui.promptModal;
              await this.GetData();
            } else {
              this.$createToastMessage({
                text: 'No se ha podido eliminar este dispositivo',
                type: 'error',
                close: false,
                fixed: true,
                alive: 3000
              });
            }
          }
        }]
      };
    },
    SerialNumberToCerts: async function (ids) {
      const localCerts = await desktopAppComunication("GetCertificatesList");
      return ids?.map(id => localCerts?.find(cert => cert.serialNumber === id || cert.subjectString === id)).filter(c => c);
    },
    GetCertificatesSerialNumber: function (certs) {
      return certs?.map(cert => cert.serialNumber || cert.subjectString);
    },
    ManangeLastAcess: function (lastAccessDate) {
      if (!lastAccessDate) return {
        text: '',
        tooltip: 'Esta máquina nunca ha accedido al piloto automático',
        statusColor: "bg-error-100"
      };else {
        const date = new Date(lastAccessDate);
        const now = new Date();
        const diffMs = now - date; // diferencia en milisegundos

        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        //const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffMinutes < 60) {
          return {
            text: diffMinutes < 1 ? 'Activo hace menos de un minuto' : `Activo hace ${diffMinutes} minutos`,
            tooltip: 'Esta máquina se ha conectado recientemente',
            statusColor: "bg-second-100"
          };
        }
        if (diffHours < 24) {
          return {
            text: diffHours == 1 ? 'Activo hace una hora' : `Activo hace ${diffHours} horas`,
            tooltip: 'Esta máquina se conectó hace más de una hora',
            statusColor: "bg-cta2-100"
          };
        }
        // Más de un día
        return {
          text: `Ultima vez activo: ${date.toLocaleDateString()}`,
          tooltip: 'Esta máquina se conectó hace más de un día',
          statusColor: "bg-error-100"
        };
      }
    }
  }
};